import { render, staticRenderFns } from "./DisplayPictureEditable.vue?vue&type=template&id=5ed8868c&scoped=true&"
import script from "./DisplayPictureEditable.vue?vue&type=script&lang=js&"
export * from "./DisplayPictureEditable.vue?vue&type=script&lang=js&"
import style0 from "./DisplayPictureEditable.vue?vue&type=style&index=0&id=5ed8868c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed8868c",
  null
  
)

export default component.exports